import script from "./sbh3.vue?vue&type=script&setup=true&lang=js"
export * from "./sbh3.vue?vue&type=script&setup=true&lang=js"

import "./sbh3.vue?vue&type=style&index=0&id=f69191f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f69191f4"]])

export default __exports__